

<mdb-carousel 
  [controls]="true" 
  [animation]="'slide'">
    <mdb-carousel-item>
      <div class="first-slide-title slide-title text-center">
        <p class="padding-bottom pb4">{{ 'WALLET_TITLE_ONE' | translate }}</p>
        <img src="assets/img/images/mapfre-card-logo.png" alt="mapfre card" style="margin-left:-30px" />
      </div>
      <div class="first-slide-image text-center">
        <img src="assets/img/images/wallet-card-slide-one.png" height="264" alt="First slide">
      </div>
      <div class="carousel-content ">
          {{ 'WALLET_CONTENT_ONE' | translate }}
      </div>
    </mdb-carousel-item>
    <mdb-carousel-item>
      <h1 class="wallet-title slide-title text-center wallet-title margin-bottom mb24">{{ 'WALLET_TITLE_TWO' | translate }}</h1>
      <div class="image text-center">
        <img src="assets/img/images/wallet-card-slide-two.png"  height="240" alt="Second slide">
      </div> 
      <div class="carousel-content ">
        {{ 'WALLET_CONTENT_TWO' | translate }}                
      </div>
    </mdb-carousel-item>
    <mdb-carousel-item>
      <h1 class="wallet-title wallet-title slide-title text-center wallet-title margin-bottom mb24">{{ 'WALLET_TITLE_THREE' | translate }}</h1>
      <div class="image text-center">
        <img src="assets/img/images/wallet-card-slide-three.png" height="240" alt="Third slide">
      </div>
      <div class="carousel-content ">
        {{ 'WALLET_CONTENT_THREE' | translate }}
      </div>
    </mdb-carousel-item>
</mdb-carousel>
